import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'asm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('officer-tasks', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      month: filter.month,
      activity: filter.activity
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('officer-tasks')
}

export {
  setTableOptions,
  getTableOptions
}
